module.exports = __webpack_public_path__ + "static/media/bg.db1e68e0.png";